module.exports = __webpack_public_path__ + "static/media/arrow-down.07f27d1d.svg";